<template lang="pug">
.subproject-area
  l-geoJson(
    v-if="show"
    :geojson="geoJson"
    :options="options"
    :optionsStyle="styles"
  )
  l-marker(
    v-if="show"
    v-for="({ latlng, icon, info }, id) in labels"
    :key="`subproject_label_${id}`"
    :lat-lng="latlng"
    :icon="icon"
    @click="$emit('change-location', { event: $event, location: info })"
  )
</template>

<script>
import L from 'leaflet'
import { clean } from '@/utils/array'

export default {
  props: {
    geoJson: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    const self = this
    return {
      labels: [],
      options: {
        filter: (feature) => (!feature.properties.parent),
        onEachFeature: (feature, layer) => {
          layer.on('click', event => self.$emit('change-location', { event, location: feature.properties }))
          const icon = L.divIcon({
            className: 'map-label',
            html: feature.properties.name,
            iconSize: [100, 40]
          })
          this.labels.push({
            latlng: layer.getBounds().getCenter(),
            info: feature.properties,
            icon
          })
        }
      }
    }
  },
  methods: {
    styles (feature) {
      return {
        color: '#000000',
        dashArray: feature.properties.lineType || '2 5',
        fillOpacity: feature.properties.opacity || 0.05
      }
    },
    removeLabels () {
      clean(this.labels)
    }
  },
  computed: {
    show () {
      return !!(this.geoJson && this.geoJson.features && this.geoJson.features.length)
    }
  },
  watch: {
    geoJson () {
      this.removeLabels()
    }
  }
}
</script>
